import { useEffect, useState } from "react";
import api from "../lib/api";
import CagnotteCard from "../components/CagnotteCard";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Search, Loader2, TrendingUp, Clock } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";

const CATEGORIES = ["Tous", "Anniversaire", "Mariage", "Solidarité", "Études", "Voyage", "Projet", "Famille", "Sport"];

export default function Explore() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("Tous");
  const [sort, setSort] = useState("recent");

  const fetchData = async () => {
    setLoading(true);
    const params = new URLSearchParams({ sort, limit: 60 });
    if (q) params.set("q", q);
    if (category !== "Tous") params.set("category", category);
    try {
      const { data } = await api.get(`/cagnottes/explore?${params}`);
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); /* eslint-disable-next-line */ }, [sort, category]);

  const onSearch = (e) => {
    e.preventDefault();
    fetchData();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="explore-page">
      <div className="mb-10">
        <p className="text-sm text-muted-foreground mb-1">Explorer</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Toutes les cagnottes</h1>
      </div>

      <form onSubmit={onSearch} className="flex gap-2 mb-6">
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher une cagnotte..." className="pl-11 h-12 rounded-full" data-testid="search-input" />
        </div>
        <Button type="submit" className="btn-gradient rounded-full h-12 px-6" data-testid="search-btn">Rechercher</Button>
      </form>

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCategory(c)}
              data-testid={`cat-${c}`}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition border ${category === c ? "gradient-gold-green text-white border-transparent" : "border-input hover:border-primary"}`}
            >
              {c}
            </button>
          ))}
        </div>
        <Tabs value={sort} onValueChange={setSort}>
          <TabsList className="rounded-full">
            <TabsTrigger value="recent" className="rounded-full" data-testid="sort-recent"><Clock className="h-3 w-3 mr-1" /> Récentes</TabsTrigger>
            <TabsTrigger value="popular" className="rounded-full" data-testid="sort-popular"><TrendingUp className="h-3 w-3 mr-1" /> Populaires</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {loading ? (
        <div className="min-h-[40vh] flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
      ) : items.length === 0 ? (
        <div className="card-soft p-16 text-center">
          <p className="text-muted-foreground">Aucune cagnotte trouvée. Essayez une autre recherche.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c) => <CagnotteCard key={c.id} cagnotte={c} />)}
        </div>
      )}
    </div>
  );
}
